<template>
<v-row :class="['im-result', getClass()]" align="center" no-gutters>
    <v-col cols="5" sm="5">
        <div :class="['d-flex align-center',$vuetify.breakpoint.smAndDown?'flex-column':'flex-row']">
            <div style="width: 140px;">
                <div class="pa-1 important font-weight-bold ">
                    <div>
                        {{ item.id }}
                    </div>
                    <div v-if="checkQTravelDetail(item)">
                        <span class="regular font-weight-bold">
                            <v-avatar size="16">
                                <img :src="q_img">
                            </v-avatar>
                            {{ item.client_observations | getQTravelDetail }}
                        </span>
                    </div>
                    <div v-if="item.hotel_contact.test" class="red--text regular font-weight-bold">
                        Test
                    </div>
                </div>
            </div>
            <v-col class="text-left">
                <div class="important text-truncate">
                    <span>{{ item.hotel_contact.name }}</span>
                </div>
                <div class="regular text-truncate">
                    <span>{{ item.hotel_contact.city }}</span><span v-if="item.hotel_contact.region">,{{ item.hotel_contact.region }}</span>
                </div>
            </v-col>
            <div style="width: 80px;" v-if="$vuetify.breakpoint.mdAndUp" class="text-center timestamp">
                <div class="detail">{{ getDate(item.timestamp) }}</div>
                <div class="faded">{{ getTime(item.timestamp) }}</div>
            </div>
        </div>
    </v-col>
    <v-col cols="3" sm="2">
        <im-period :check_in="getDate(item.check_in)" :check_out="getDate(item.check_out)" />
    </v-col>
    <v-col cols="4" sm="5">
        <v-row align="center">
            <v-col cols="12" class="text-right" v-if="$vuetify.breakpoint.smAndDown">
                {{ getDate(item.timestamp) }}
            </v-col>
            <v-col cols="12" md="3" class="text-right">
                <im-price :price="item.pricing.total" :currency="item.pricing.currency" />
                <div v-if="$vuetify.breakpoint.mdAndUp" class="faded">
                    {{item.nights}}N X {{item.rooms}}R= {{item.rooms_nights}}RN
                </div>
            </v-col>
            <v-col cols="12" md="5" class="text-left">
                <div class="important pt-1 text-truncate">
                    {{ item.client_contact.first_name }} {{ item.client_contact.last_name }}
                </div>
                <div class="detail" v-if="$vuetify.breakpoint.mdAndUp">
                    {{ item.client_contact.contact.phone }}
                </div>
            </v-col>
            <v-col v-if="$vuetify.breakpoint.mdAndUp" md="4" class="text-left">
                <div class="detail text-truncate">
                    {{ item.agency.name }}
                </div>
                <div class="detail" v-if="item.agency.commissioning && item.agency.commissioning.agency && item.agency.commissioning.agency.commission_percentage">
                    {{ item.agency.commissioning.agency.commission_percentage }} %
                </div>
            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js";
import IMPeriod from '../small-components/IMPeriod.vue';
import IMPrice from '../small-components/IMPrice.vue';
import QImg from '../../assets/q-travel.svg';

export default {

    components: {
        'im-period': IMPeriod,
        'im-price': IMPrice,
    },

    props: {
        item: {
            type: Object,
            default: defaults.reservation_item
        },
    },

    data: () => {
        return {
            q_img: QImg,
        }
    },

    filters: {
        getQTravelDetail(value) {
            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.exec(value)?.[1];
        },
    },

    methods: {

        emitClick() {
            this.$emit('click');
        },

        getClass() {
            switch (this.item.status) {
            case 'booked':
                return 'im-result-success';
            case 'no-show':
                return 'im-result-warning';
            case 'canceled':
                return 'im-result-danger';
            default:
                return '';
            }
        },

        getDate(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('YYYY-MM-DD');
        },

        getTime(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('HH:mm:ss');
        },

        checkQTravelDetail(reservation) {
            if (reservation?.channel === 'Q-Travel') {
                return true;
            }

            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.test(reservation.client_observations);
        },

    },

}
</script>

<style>
.booked {
    border-left: 5px solid #4CAF50;
}

.no-show {
    border-left: 5px solid #FFC107;
    background-color: #FFF8E1;
}

.canceled {
    border-left: 5px solid #F44336;
    background-color: #FFEBEE;
}

.reservation-result {
    color: #4a4a4a;
    font-size: 12px;
}

.booking-code {
    font-size: 14px;
    font-weight: 700;
}

.timestamp {
    font-size: 10px;
}

.timestamp .time {
    font-size: 9px;
    color: #666666;
}
</style>
